import * as Sentry from "@sentry/react";
import { History } from "history";

import store from "../../store";
import { cleanupTaskFilters } from "@src/multiCustodian/pages/Advisor/Tasks/storage";
import { resetTaskFilters } from "@src/multiCustodian/pages/Advisor/Tasks/utils";

export default function logUserOut(reason: string, history?: History) {
  console.log("Logging user out, reason:", reason);
  const isAdvisor = store.getState().main_Reducer.user.isAdvisor ?? false;

  // Reset and clean up task filters when logging out
  if (isAdvisor) {
    try {
      // First reset the filters to default values
      const resetSuccess = resetTaskFilters();
      if (!resetSuccess) {
        // Log the error but don't block logout process
        Sentry.captureMessage("Failed to reset task filters during logout", {
          level: "warning",
        });
      }

      // Then clean up tab-specific filters
      cleanupTaskFilters();
    } catch (error) {
      console.error("Error handling task filters during logout:", error);
      Sentry.captureException(error);
    }
  }

  Sentry.addBreadcrumb({
    message: "Logging user out",
    data: { isAdvisor: isAdvisor, reason: reason },
  });

  const replace = history
    ? history.replace
    : window.location.replace.bind(window.location);

  Promise.resolve()
    .then(() => Sentry.flush(1000))
    .then(() => {
      const isAdvisorStr = isAdvisor ? "true" : "false";

      const queryParams = `?reason=${encodeURI(
        reason
      )}&isAdvisor=${isAdvisorStr}`;

      if (isAdvisor) {
        return replace(`/Advisor/Logout${queryParams}`);
      } else {
        return replace(`/Logout${queryParams}`);
      }
    })
    .catch((e) => {
      console.error(e);
    });
}
